<div class="main-container-school-registration" *ngIf="!preLoader">
  <div class="sub-container-registration">
    <div class="slider">
      <app-slider></app-slider>
    </div>
    <div class="content-for-registration">
      <div class="help-link-registration">
        <div class="headerbar-right">
         <app-language-dropdown></app-language-dropdown>
        <a [href]="brand.helpUrl" target="_blank" class="link-for-contact-registration">
          {{ 'help' | translate  }}</a>
          </div>
      </div>
      <div [ngClass]="{
          'sub-container-data-registration': !otpPage,
          'display-none': otpPage
        }">
        <div class="header-of-registration">
          <div class="logo-registration">
            <img *ngIf="brand.id" [src]="brand.logoPath" alt="logo" class="registration-logo-img" />
          </div>
          <div class="register-message">
            {{ 'registerInstitute' | translate  }}
          </div>
          <div class="second-register-message">
            {{ 'bluewingsMessage' | translate:{ brandName: brand.name } }}
          </div>
        </div>
        <div class="registration-data-collector">
          <div class="registration-inputs">
            <label for="institute-name" [ngClass]="{
                'registration-label-input': !classInstitutionError,
                'registration-label-input-error': classInstitutionError
              }">{{ 'instituteName' | translate 
              }}<sup class="mandatory-field">*</sup></label><br />
            <input type="text" placeholder="{{ 'placeHolderInstitute' | translate  }}" id="institute-name" [ngClass]="{
                'input-field-registration-page': !classInstitutionError,
                'input-field-registration-page-error': classInstitutionError
              }" #institutionName (input)="handleDebounceInstituteName(institutionName)" [disabled]="loader"
              maxlength="200" autocomplete="off" [(ngModel)]="formData.instituteName" />
            <br />
            <div *ngIf="classInstitutionError" class="error-message-registration">
              <span class="error-message">{{
                'instituteNameError' | translate 
                }}</span>
            </div>
          </div>
          <div class="registration-inputs mobile-number-selection-box">
            <label for="mobile-number" [ngClass]="{
                'registration-label-input': !invalidMobileNumber,
                'registration-label-input-error': invalidMobileNumber
              }">{{ 'mobileNumber' | translate 
              }}<sup class="mandatory-field">*</sup></label><br />
            <input type="text" placeholder="{{ 'placeHolderMobile' | translate  }}" id="mobile-number" [ngClass]="{
                'input-field-registration-page': !invalidMobileNumber,
                'input-field-registration-page-error': invalidMobileNumber
              }" [disabled]="loader" #mobileNumber (input)="handleDebounceMobileNumber(mobileNumber)" pattern="[0-9]*"
              (keydown)="handleKeyDown($event)" autocomplete="off" [(ngModel)]="formData.mobileNumber" />
            <div *ngIf="invalidMobileNumber" class="error-message-registration">
              <span class="error-message">{{ 'validNumber' | translate  }}</span>
            </div>
          </div>
          <div class="registration-inputs">
            <label for="email-id" [ngClass]="{
                'registration-label-input': !validEmail,
                'registration-label-input-error': validEmail
              }">{{ 'emailId' | translate  }}<sup class="mandatory-field">*</sup></label><br />
            <input type="text" placeholder="{{ 'placeHolderEmail' | translate  }}" id="email-id" [disabled]="loader" [ngClass]="{
                'input-field-registration-page': !validEmail,
                'input-field-registration-page-error': validEmail
              }" #email (input)="handleDebounceEmail(email)" autocomplete="off" [(ngModel)]="formData.email" /><br />
            <div *ngIf="validEmail" class="error-message-registration">
              <span class="error-message">{{ 'validEmail' | translate  }}</span>
            </div>
          </div>
          <div class="registration-inputs">
            <label for="url" [ngClass]="{
                'registration-label-input': !validUrl,
                'registration-label-input-error': validUrl
              }">{{ 'urlInstitution' | translate 
              }}<sup class="mandatory-field">*</sup></label><br />
            <div class="url-input-container">
              <div class="image-container">
                <div *ngIf="validUrlLength >= 2">
                  <img src="../../assets/img/check_green.png" alt="icon" *ngIf="domainAvailable"
                    class="available-icon" />
                  <img src="../../assets/img/cross_red.png" alt="icon" *ngIf="!domainAvailable"
                    class="available-icon" />
                </div>

                <input type="text" placeholder="{{ 'placeHolderUrl' | translate  }}" id="url" [ngClass]="{
                    'input-field-registration-page': defaultUrlValidator,
                    'input-field-registration-page-error': validUrl,
                    'input-field-registration-page-available': domainAvailable,
                    'input-field-registration-page-unavailable':
                      !domainAvailable && !defaultUrlValidator
                  }" [disabled]="loader" #url (input)="handleDebounceUrl(url)" autocomplete="off"
                  [(ngModel)]="formData.url" pattern="[a-z]+" (keyup.enter)="submitPage()" />
              </div>

              <div class="url-prefixer">.{{ brand.domainSuffix }}</div>
              <br />
            </div>
            <div *ngIf="validUrl" class="error-message-registration">
              <span class="error-message">{{ urlError }}</span>
            </div>
          </div>
          <div class="registration-inputs url-suggestion-main-container">
            <div class="url-suggestions" *ngIf="schoolDomainSuggested && schoolDomainSuggested.length > 0">
              <span class="suggested-urls" *ngFor="let item of schoolDomainSuggested" (click)="getValueOfUrl(item)">{{
                item }}</span>
            </div>
          </div>
          <button class="registration-continue-btn" (click)="submitPage()" [disabled]="loader">
            <ng-container *ngIf="loader; else stringContinue">
              <app-button-loader></app-button-loader>
            </ng-container>
            <ng-template #stringContinue>
              {{ 'continue' | translate  }}
            </ng-template>
          </button>
        </div>
      </div>
      <div [ngClass]="{
          'otp-verification-main-container': otpPage,
          'display-none': !otpPage
        }" *ngIf="otpPage">
        <div class="header-of-otp-verification">
          <img *ngIf="brand.id" [src]="brand.logoPath" alt="logo" class="registration-logo-img" />
        </div>
        <div class="main-data-container-of-verification-otp">
          <div class="main-heading-otp-verification">
            {{ 'otpVerification' | translate  }}
          </div>
          <div class="all-otp-inputs">
            <div class="input-containers-of-mobile-otp-verification" *ngIf="brand.mobileNumberVerificationWhileRegistration">
              <div class="message-for-mobile-otp">
                {{ 'mobileOtp' | translate  }}
              </div>
              <div class="input-box-for-mobile-otp">
                <input type="text" maxlength="1" (keyup)="tabChangeMobile(1)" [(ngModel)]="mobileOtp[0]"
                  class="mobile-input" (keydown)="handleKeyDown($event)" (input)="checkInput()" />
                <input type="text" maxlength="1" (keyup)="tabChangeMobile(2)" [(ngModel)]="mobileOtp[1]"
                  class="mobile-input" (keydown)="handleKeyDown($event)" (input)="checkInput()" />
                <input type="text" maxlength="1" (keyup)="tabChangeMobile(3)" [(ngModel)]="mobileOtp[2]"
                  class="mobile-input" (keydown)="handleKeyDown($event)" (input)="checkInput()" />
                <input type="text" maxlength="1" (keyup)="tabChangeMobile(4)" [(ngModel)]="mobileOtp[3]"
                  class="mobile-input" (keydown)="handleKeyDown($event)" (input)="checkInput()" />
              </div>
            </div>
            <div class="input-containers-of-mobile-otp-verification">
              <div class="message-for-mobile-otp">
                {{ 'emailOtp' | translate  }}
              </div>
              <div class="input-box-for-mobile-otp">
                <input type="text" maxlength="1" (keyup)="tabChangeEmail(1)" [(ngModel)]="emailOtp[0]"
                  class="email-input" (keydown)="handleKeyDown($event)" (input)="checkInput()" />
                <input type="text" maxlength="1" (keyup)="tabChangeEmail(2)" [(ngModel)]="emailOtp[1]"
                  class="email-input" (keydown)="handleKeyDown($event)" (input)="checkInput()" />
                <input type="text" maxlength="1" (keyup)="tabChangeEmail(3)" [(ngModel)]="emailOtp[2]"
                  class="email-input" (keydown)="handleKeyDown($event)" (input)="checkInput()" />
                <input type="text" maxlength="1" (keyup)="tabChangeEmail(4)" [(ngModel)]="emailOtp[3]"
                  class="email-input" (keydown)="handleKeyDown($event)" (input)="checkInput()"
                  (keyup.enter)="otpVerification()" />
              </div>
            </div>
          </div>
        </div>
        <div class="button-for-otp">
          <div class="resend-timer">
            <button class="link-for-resend" [disabled]="!resendOtp || attemptOtp == 0" (click)="resendOtpFunction()">
              {{ 'resendOtp' | translate  }}
            </button>
            <span class="timer">{{ 'in' | translate  }} {{ timer }} {{ 'sec' | translate  }} </span><span class="attempts-left">({{
              attemptOtp }} {{ 'attempt' | translate  }})</span>
          </div>
          <div class="button-verify-container">
            <button class="button-verify" [disabled]="verificationLoader" (click)="otpVerification()">
              <ng-container *ngIf="verificationLoader; else stringVerify">
                <app-button-loader></app-button-loader>
              </ng-container>
              <ng-template #stringVerify>
                {{ 'verify' | translate  }}
              </ng-template>
            </button>
          </div>
          <div class="back-button">
            <span (click)="goBack()" class="link-back">
              {{ 'back' | translate  }}
            </span>
          </div>
        </div>
      </div>

      <div class="link-for-login">
        <span class="message-for-login-link"> {{ 'already' | translate  }} </span>
        <a href="javascript:void(0)" class="login-link-registration-page" (click)="openLogin()">
          {{ 'login' | translate  }}
        </a>
      </div>
    </div>
  </div>
</div>
<div style="
    background: white;
    width: 100%;
    text-align: center;
    height: 100%;
    position: fixed;
    padding-top: 35vh;
  " *ngIf="preLoader">
  <img *ngIf="brand.id" id="animatedLoader" alt="logo" class="animated infinite pulse" [src]="brand.logoPath"
    style="width: 125px" />
</div>